import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=6463674a&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports